import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Gallery from "@/components/site/Gallery";
import Marquee from "@/components/site/Marquee";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Careers from "@/components/site/Careers";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Gallery />
        <About />
        <Services />
        <Industries />
        <Testimonials />
        <FAQ />
        <QuoteForm />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
